<div class="cont-loading display-center py-5" *ngIf="loadPage">
  <app-load-page [colorFtd]="loadPage"></app-load-page>
</div>
<ng-container *ngIf="!loadPage" >
  <div *ngFor="let component of providerData">
  <section class="main-body-carousel" *ngIf="component.componentType === providerComponentsEnum.SMALL_BANNER">
    <div class="cont-items" *ngFor="let item of component.list">
      <img class="body-carousel-img" (click)="reditect(item.redirectURL)" [src]="item.urlBanner" [alt]="item.firstDescription">
    </div>
  </section>
  <section class="main-body-label" *ngIf="component.componentType === providerComponentsEnum.HTML_LABEL && (isBrowser || !isBrowser && component?.ssr)">
    <p class="main-body-html-label" [innerHTML]="component.label | safeHtml"></p>
  </section>
  <section class="main-body-square-banner" *ngIf="isBrowser && component.list && component?.componentType === providerComponentsEnum.RECT_BANNER">
    <div class="square-banner-item" *ngFor="let item of component.list">
      <img [src]="item.urlBanner" (click)="reditect(item.redirectURL)" [alt]="item.firstDescription" class="square-banner-img">
    </div>
  </section>
  <section class="main-body-two-banner" *ngIf="isBrowser && component.list && component?.componentType === providerComponentsEnum.TWO_RECT_BANNER">
    <div class="two-banner-item" *ngFor="let item of component.list">
      <img [src]="item.urlBanner" (click)="reditect(item.redirectURL)" [alt]="item.firstDescription" class="two-banner-img">
    </div>
  </section>
  <section class="main-body-shortcut-banner" *ngIf="isBrowser && component.list && component?.componentType === providerComponentsEnum.SHORTCUT_BANNER">
    <virtual-scroller [items]="component.list" class="virtual-scroll" [horizontal]="true" (vsEnd)="eventScroll($event, component.list)">
      <div class="cont-items" *ngFor="let item of component.list">
        <div (click)="reditect(item.redirectURL)" class="ad-wrapper">
          <img class="img pr-2 mobile-ad-img" [src]="item.urlBanner" [alt]="item.firstDescription">
        </div>
      </div>
    </virtual-scroller>
  </section>
  <section class="main-body-categories" *ngIf="isBrowser && component.list && component?.componentType === providerComponentsEnum.GRID_BLOG_LIST">
    <div class="grid-item-blog" *ngFor="let item of component.list">
      <img [src]="item.urlBanner" (click)="reditect(item.redirectURL)" [alt]="item.firstDescription" class="blog-img">
      <h4 class="blog-title">{{ item.label }}</h4>
      <p class="blog-description">{{ item.description }}</p>
    </div>
  </section>
  <section class="main-body-item-list" *ngIf="isBrowser && component.list && component?.componentType === providerComponentsEnum.ITEM_LIST_TWO_ROWS">
    <app-carousel-ftd [arrayProducts]="component.products" *ngIf="isBrowser && dataLoaded" [isHome]="false" [isCarousel]="true"></app-carousel-ftd>
  </section>
  <section class="main-body-tutorials" *ngIf="isBrowser && component.list && component?.componentType === providerComponentsEnum.VIDEO_LIST">
    <app-carousel-ftd *ngIf="isBrowser" [arrayProducts]="component.list" [spaceDelete]="1" [videoOnly]="true"></app-carousel-ftd>
  </section>
</div>
</ng-container>
